// extracted by mini-css-extract-plugin
export default {"page":"AppLayout_page__OtOS0","pageRow":"AppLayout_pageRow__8Elmb","main":"AppLayout_main__EmwhI","workerMain":"AppLayout_workerMain__0YOUR"};